import { render, staticRenderFns } from "./NavFixed.vue?vue&type=template&id=0c4b5b3c&"
import script from "./NavFixed.vue?vue&type=script&lang=js&"
export * from "./NavFixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports